import { BasketOffIcon } from './BasketOffIcon';

/**
 * author: Michael Irigoyen
 * id FC2C74AA-57B1-4E13-A499-AA81CBE6670A
 * name basket-off
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-off.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketOffIcon = BasketOffIcon;
export default ShoppingBasketOffIcon